<template>
	<div class="shop_register">
		<div class="shop_top">
			<shop-top :subnav_show="false" :change_color="true"></shop-top>
		</div>
		<div class="content-style" v-html="content"></div>
		<shop-foot></shop-foot>
	</div>
</template>

<script>
	import ShopTop from "@/components/home/public/head.vue"
	import ShopFoot from "@/components/home/public/shop_foot.vue"
	import {
		getActicleByTitle
	} from "@/api/api.js"
	export default {
		components: {
			ShopTop,
			ShopFoot,
		},
		props: {},
		data() {
			return {
				content: ""
			};
		},
		watch: {},
		computed: {},
		methods: {},
		created() {
			getActicleByTitle("消费者告知书").then(res=>{
				if(res.code == 0){
					this.content = res.data.content
				}
			})
		},
		mounted() {}
	};
</script>
<style lang="scss" scoped>
	.content-style{
		padding: 5em 5em 5em 5em;
	}
</style>
